import { render, staticRenderFns } from "./ModalOccurrence.vue?vue&type=template&id=2b48b02c"
import script from "./ModalOccurrence.vue?vue&type=script&lang=js"
export * from "./ModalOccurrence.vue?vue&type=script&lang=js"
import style0 from "./ModalOccurrence.vue?vue&type=style&index=0&id=2b48b02c&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b48b02c')) {
      api.createRecord('2b48b02c', component.options)
    } else {
      api.reload('2b48b02c', component.options)
    }
    module.hot.accept("./ModalOccurrence.vue?vue&type=template&id=2b48b02c", function () {
      api.rerender('2b48b02c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/occurrences/components/ModalOccurrence.vue"
export default component.exports